import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, Instagram, Facebook, Heart, ArrowUpRight, ShieldCheck, FileText } from 'lucide-react';
import { Logo } from './Logo';

const Footer = () => {
  // Configurações de Contato do Site
  const contactEmail = "empregamaisrondonia@gmail.com";
  const contactPhoneDisplay = "(69) 99991-4037";
  const whatsappLink = "https://wa.me/5569999914037"; 
  const gmailLink = `https://mail.google.com/mail/?view=cm&fs=1&to=${contactEmail}`;

  // === Desenvolvedor do site ===
  const devName = "Victor Guilherme";
  const devRole = "Programador Full Stack";
  const devInstagram = "https://instagram.com/vctmaia";
  const devWhatsapp = "https://wa.me/5548991245413";

  return (
    <footer className="bg-gradient-to-br from-[#003b4a] via-[#004d5a] to-[#003b4a] text-white print:hidden">
      <div className="container mx-auto px-6 md:px-12 py-16">

        {/* Grid Principal */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">

          {/* Coluna 1: Branding */}
          <div>
            <Link to="/" className="inline-block mb-6 group transition-transform hover:scale-[1.02]">
              <Logo theme="dark" />
            </Link>

            <p className="text-white/70 leading-relaxed mb-6 max-w-sm">
              Conectando talentos às melhores oportunidades de emprego em todo o estado de Rondônia.
            </p>

            <div className="flex gap-3">
              <a href="https://instagram.com/empregamaisro" target="_blank" rel="noopener noreferrer"
                className="w-10 h-10 rounded-xl bg-white/10 flex items-center justify-center hover:bg-gradient-to-br from-purple-500 to-pink-500 transition-all">
                <Instagram className="w-5 h-5" />
              </a>

              <a href="https://facebook.com/empregamaisro" target="_blank" rel="noopener noreferrer"
                className="w-10 h-10 rounded-xl bg-white/10 flex items-center justify-center hover:bg-gradient-to-br from-blue-500 to-blue-600 transition-all">
                <Facebook className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Coluna 2: Navegação Institucional (Crítico para AdSense) */}
          <div>
            <h4 className="font-heading font-semibold text-lg mb-6 flex items-center gap-2">
              Institucional <span className="h-1 w-8 bg-lime-500 rounded-full" />
            </h4>

            <ul className="space-y-3">
              {[
                { name: 'Buscar Vagas', href: '/vagas' },
                { name: 'Notícias & Editais', href: '/noticias' },
                { name: 'Teste DISC', href: '/disc' },
                { name: 'Termos de Uso', href: '/termos', icon: <FileText className="w-4 h-4" /> },
                { name: 'Privacidade', href: '/privacidade', icon: <ShieldCheck className="w-4 h-4" /> }
              ].map((link, i) => (
                <li key={i}>
                  <Link to={link.href} className="flex items-center gap-2 text-white/70 hover:text-lime-400 transition-colors">
                    {link.icon || <ArrowUpRight className="w-4 h-4" />}
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Coluna 3: Fale Conosco */}
          <div>
            <h4 className="font-heading font-semibold text-lg mb-6 flex items-center gap-2">
              Fale Conosco <span className="h-1 w-8 bg-teal-500 rounded-full" />
            </h4>

            <ul className="space-y-4">
              <li>
                <a href={gmailLink} target="_blank" rel="noopener noreferrer"
                  className="flex items-center gap-3 text-white/70 hover:text-white transition-colors">
                  <Mail className="w-5 h-5" />
                  {contactEmail}
                </a>
              </li>

              <li>
                <a href={whatsappLink} target="_blank" rel="noopener noreferrer"
                  className="flex items-center gap-3 text-white/70 hover:text-white transition-colors">
                  <Phone className="w-5 h-5" />
                  {contactPhoneDisplay}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Rodapé Inferior */}
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col gap-8">

          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-white/50 text-sm">
              Feito com <Heart className="inline w-4 h-4 text-red-400 fill-red-400 animate-pulse" /> em Rondônia © {new Date().getFullYear()}
            </p>

            <div className="flex gap-6 text-sm text-white/50">
              <Link to="/termos" className="hover:text-white transition-colors">Termos de Uso</Link>
              <Link to="/privacidade" className="hover:text-white transition-colors">Privacidade</Link>
            </div>
          </div>

          {/* CARTÃO PREMIUM DO DEV */}
          <div className="relative group max-w-3xl mx-auto w-full">
            <div className="absolute -inset-0.5 bg-gradient-to-r from-lime-400 via-teal-400 to-cyan-500 rounded-2xl blur opacity-30 group-hover:opacity-60 transition-all"></div>

            <div className="relative bg-slate-900/80 backdrop-blur-xl border border-white/10 rounded-2xl p-6 flex flex-col md:flex-row items-center justify-between gap-6">
              
              <div className="flex items-center gap-5">
                <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-lime-400 to-teal-500 flex items-center justify-center text-slate-900 font-black text-xl shadow-lg">
                  VG
                </div>

                <div className="text-left">
                  <p className="text-sm uppercase tracking-widest text-lime-400 font-semibold">
                    Desenvolvido por
                  </p>
                  <p className="text-xl font-bold text-white">{devName}</p>
                  <p className="text-white/60 text-sm">{devRole}</p>
                </div>
              </div>

              <div className="flex gap-4">
                <a href={devInstagram} target="_blank" rel="noopener noreferrer"
                  className="px-5 py-2.5 rounded-xl bg-gradient-to-r from-pink-500 to-purple-600 text-white font-medium flex items-center gap-2 hover:scale-105 transition">
                  <Instagram className="w-4 h-4" /> Instagram
                </a>

                <a href={devWhatsapp} target="_blank" rel="noopener noreferrer"
                  className="px-5 py-2.5 rounded-xl bg-gradient-to-r from-green-500 to-emerald-600 text-white font-medium flex items-center gap-2 hover:scale-105 transition">
                  <Phone className="w-4 h-4" /> WhatsApp
                </a>
              </div>

            </div>
          </div>

        </div>
      </div>
    </footer>
  );
};

export default Footer;